import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=49f88210&"
import script from "./Switch.vue?vue&type=script&lang=ts&"
export * from "./Switch.vue?vue&type=script&lang=ts&"
import style0 from "./Switch.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports